export const TESTIDS = {
    shell: {
        logo: "shell-header-logo",
        sidebarToggle: "shell-sidebar-toggle",
        userMenu: "shell-header-user-menu",
        settingsLink: "shell-footer-settings",
        logout: "shell-footer-logout"
    },
    auth: {
        email: "admin-auth-email",
        password: "admin-auth-password",
        submit: "admin-auth-submit"
    },
    adminLayout: {
        root: "admin-layout-root",
        globalHeader: "admin-layout-global-header",
        globalHeaderContent: "admin-layout-global-header-content",
        pageHeader: "admin-layout-page-header",
        scrollContent: "admin-layout-scroll-content",
        globalSearch: "admin-layout-global-search",
        businessAlerts: "admin-layout-business-alerts",
        userMenu: "admin-layout-user-menu"
    },
    pilotage: {
        fixedCosts: {
            totalMonthly: "fixed-costs-total-monthly",
            totalAnnual: "fixed-costs-total-annual"
        },
        dashboard: {
            container: "pilotage-dashboard-content",
            page: "admin-dashboard",
            pageHeader: "pilotage-page-header",
            loadingState: "pilotage-dashboard-loading",
            loadingSkeleton: "pilotage-dashboard-loading-skeleton",
            errorState: "pilotage-dashboard-error",
            lastUpdated: "pilotage-dashboard-last-updated",
            refreshButton: "pilotage-dashboard-refresh",
            quickActionsBar: "pilotage-dashboard-quick-actions-bar",
            currentYearBadge: "pilotage-dashboard-current-year-badge",
            objectiveSelector: "pilotage-dashboard-objective-selector",
            objectiveEmptyCta: "pilotage-dashboard-objective-empty-cta",
            quickActionCreateMission: "pilotage-dashboard-quick-action-create-mission",
            quickActionAddCollaborator: "pilotage-dashboard-quick-action-add-collaborator",
            quickActionAddFixedCost: "pilotage-dashboard-quick-action-add-fixed-cost",
            quickActionObjectives: "pilotage-dashboard-quick-action-objectives",
            stickySummary: "pilotage-dashboard-sticky-summary",
            stickyAnchorKpis: "pilotage-dashboard-sticky-anchor-kpis",
            stickyAnchorPnl: "pilotage-dashboard-sticky-anchor-pnl",
            stickyAnchorProjection: "pilotage-dashboard-sticky-anchor-projection",
            stickyAnchorFixedCosts: "pilotage-dashboard-sticky-anchor-fixed-costs",
            stickyAnchorCollaborators: "pilotage-dashboard-sticky-anchor-collaborators",
            kpiConsultantsActifs: "pilotage-dashboard-kpi-consultants-actifs",
            kpiTjmMoyen: "pilotage-dashboard-kpi-tjm-moyen",
            kpiTauxOccupation: "pilotage-dashboard-kpi-taux-occupation",
            kpiCaConsultant: "pilotage-dashboard-kpi-ca-consultant",
            kpiCaMensuel: "pilotage-dashboard-kpi-ca-mensuel",
            kpiCaMensuelValue: "pilotage-dashboard-kpi-ca-mensuel-value",
            kpiCaAnnuel: "pilotage-dashboard-kpi-ca-annuel",
            kpiFixedCostsMonthly: "pilotage-dashboard-kpi-fixed-costs-monthly",
            kpiFixedCostsAnnual: "pilotage-dashboard-kpi-fixed-costs-annual",
            kpiNetProfitMonthly: "pilotage-dashboard-kpi-net-profit-monthly",
            kpiNetProfitAnnual: "pilotage-dashboard-kpi-net-profit-annual",
            kpiBeneficeAnnuel: "pilotage-dashboard-kpi-benefice-annuel",
            kpiMargeMoyenne: "pilotage-dashboard-kpi-marge-moyenne",
            kpiMissionsActives: "pilotage-dashboard-kpi-missions-actives",
            kpiMissionsFreelance: "pilotage-dashboard-kpi-missions-freelance",
            kpiMissionsCdi: "pilotage-dashboard-kpi-missions-cdi",
            kpiMissionsIntermediaire: "pilotage-dashboard-kpi-missions-intermediaire",
            profitabilityTable: "pilotage-profitability",
            intercontratPanel: "pilotage-intercontrat",
            forecastChart: "pilotage-forecast-revenue",
            businessAlerts: "pilotage-business-alerts",
            consultantRevenueTable: "pilotage-consultant-revenue",
            blocCaConsultant: "pilotage-consultant-revenue",
            collaboratorsRevenueTable: "pilotage-dashboard-collaborators-revenue",
            collaboratorsRevenueViewMore: "pilotage-collaborators-revenue-view-more",
            collaboratorsSearchInput: "pilotage-dashboard-collaborators-search",
            collaboratorsTableSkeleton: "pilotage-dashboard-collaborators-table-skeleton",
            chartContracts: "pilotage-chart-contracts",
            chartClients: "pilotage-dashboard-chart-clients",
            clientChart: "pilotage-dashboard-chart-clients",
            clientChartFigure: "pilotage-dashboard-chart-clients-figure",
            clientChartLegend: "pilotage-dashboard-chart-clients-legend",
            pnlSimplified: "pilotage-dashboard-pnl-simplified",
            fixedCostsTopCategories: "pilotage-dashboard-fixed-costs-top-categories",
            clientChartLegendItem: "pilotage-dashboard-chart-clients-legend-item",
            quickMissions: "pilotage-dashboard-quick-missions",
            quickClients: "pilotage-dashboard-quick-clients",
            quickCollaborateurs: "pilotage-dashboard-quick-collaborateurs",
            quickFixedCosts: "pilotage-dashboard-quick-fixed-costs"
        }
    },
    PILOTAGE_STICKY_SUMMARY: "pilotage-sticky-summary",
    simulation: {
        page: "simulation-page",
        container: "simulation-page",
        blocHypotheses: "simulation-bloc-hypotheses",
        readOnlyBanner: "simulation-read-only-banner",
        modeFreelance: "simulation-mode-freelance",
        modeCdi: "simulation-mode-cdi",
        computeStatus: "simulation-compute-status",
        runButton: "simulation-run",
        resetButton: "simulation-reset",
        retryButton: "simulation-retry",
        kpiCaMensuel: "simulation-kpi-ca-mensuel",
        kpiCaYear: "simulation-kpi-ca-year",
        kpiCaAnnuel: "simulation-kpi-ca-year",
        kpiProfitYear: "simulation-kpi-profit-year",
        kpiBeneficeAnnuel: "simulation-kpi-profit-year",
        kpiMargin: "simulation-kpi-margin",
        kpiMargeMoyenne: "simulation-kpi-margin",
        blocIntermediaire: "simulation-bloc-intermediaire",
        kpiIntermediaryAnnual: "simulation-impact-annual",
        kpiCommissionDay: "simulation-commission-day",
        kpiIntermediary: "simulation-kpi-intermediary",
        netSoldSection: "simulation-net-sold",
        intermediarySection: "simulation-intermediary-section",
        costBreakdownChart: "simulation-cost-breakdown",
        fieldTace: "simulation-field-tace",
        fieldTjm: "simulation-field-tjm",
        fieldIntermediary: "simulation-field-intermediary",
        fieldSalaire: "simulation-field-salaire",
        cdiDailyCost: "simulation-cdi-daily-cost"
    },
    recruitment: {
        dashboard: {
            page: "recruitment-dashboard-page",
            kpiActiveOffers: "recruitment-kpi-offres-actives",
            kpiTotalApplications: "recruitment-kpi-total-applications",
            kpiAvgPerOffer: "recruitment-kpi-moyenne-par-offre",
            kpiConversionRate: "recruitment-kpi-taux-conversion",
            chartMonthly: "recruitment-chart-monthly",
            chartDepartments: "recruitment-chart-departments",
            chartTopOffers: "recruitment-chart-top-offers"
        },
        offres: {
            page: "recruitment-offres-page",
            table: "recruitment-offres-table"
        },
        candidatures: {
            page: "recruitment-candidatures-page",
            table: "recruitment-candidatures-table"
        }
    }
};
